import { buildUrl } from "../ReusableFunctions/reusableFunctions";
import { SERVER_URLS } from "../appConstants";
import { getToken } from "./authentication";

export const getPilotsPerformanceReport = async ({
  fromDate,
  toDate,
  pageSize,
  pageNumber,
  orderBy,
  orderType,
}) => {
  const token = getToken();
  const url = buildUrl(
    `${SERVER_URLS.BACKEND_SERVER}/dsp/reports/pilots-performance`,
    {
      fromDate,
      toDate,
      pageSize,
      pageNumber,
      orderBy,
      orderType,
    },
  );

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();
  // console.log("Pilots performance report data:", data);
  if (!response.ok) {
    throw new Error(
      data?.message || "Something went wrong while fetching report.",
    );
  }

  return data;
};
export const getOrderPerformanceReport = async ({
  fromDate,
  toDate,
  pageSize,
  pageNumber,
  orderBy,
  orderType,
}) => {
  const token = getToken();
  const url = buildUrl(
    `${SERVER_URLS.BACKEND_SERVER}/dsp/reports/orders-performance`,
    {
      fromDate,
      toDate,
      pageSize,
      pageNumber,
      orderBy,
      orderType,
    },
  );

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();
  console.log("Order performance report data:", data);
  if (!response.ok) {
    throw new Error(
      data?.message || "Something went wrong while fetching report.",
    );
  }

  return data;
};
export const downloadPilotsPerformanceReportExcel = async ({
  fromDate,
  toDate,
  orderBy,
  orderType,
}) => {
  const token = getToken();
  const url = buildUrl(
    `${SERVER_URLS.BACKEND_SERVER}/dsp/reports/pilots-performance/download`,
    {
      fromDate,
      toDate,
      orderBy,
      orderType,
    },
  );

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    let msg = "Something went wrong while downloading report.";
    try {
      const data = await response.json();
      msg = data?.message || msg;
    } catch (e) {}
    throw new Error(msg);
  }

  const blob = await response.blob();
  return blob;
};
export const downloadOrderPerformanceReportExcel = async ({
  fromDate,
  toDate,
  orderBy,
  orderType,
}) => {
  const token = getToken();
  const url = buildUrl(
    `${SERVER_URLS.BACKEND_SERVER}/dsp/reports/order-performance/download`,
    {
      fromDate,
      toDate,
      orderBy,
      orderType,
    },
  );

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    let msg = "Something went wrong while downloading report.";
    try {
      const data = await response.json();
      msg = data?.message || msg;
    } catch (e) {}
    throw new Error(msg);
  }

  const blob = await response.blob();
  return blob;
};
